module.exports = __webpack_public_path__ + "staticcomp/img/cover.2493902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/cover.jpg
// module id = 2bhG
// module chunks = 39